<template>
    <main>
        <div class="armory-header">
            <h1 class="display-m">Armory</h1>
            <TabComponent :tabs="tabs" :active-tab="activeTab" @tab-changed="updateActiveTab" />
        </div>
        <div class="tab-content">
            <component v-if="activeComponent" :is="activeComponent"></component>
            <p v-else>No hay contenido disponible.</p>
        </div>
    </main>
</template>

<style scoped>
main {
    display: flex;
    padding: 24px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    flex-shrink: 0;
}

.tab-content {
    width: 100%;
}

.armory-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    align-self: stretch;
}

@media screen and (max-width: 640px) {
    .armory-header{
        flex-direction: column;
        gap: 12px;
    }
}
</style>

<script>
import { markRaw } from 'vue';

import AttackArmoryView from './AttackArmoryView.vue';
import DefenseArmoryView from './DefenseArmoryView.vue';
import TabComponent from '@/components/core/TabComponent.vue';

export default {
    name: 'ArmoryView',
    components: {
        TabComponent
    },
    data() {
        return {
            tabs: [
                { name: 'attack', route: './AttackArmoryView.vue', label: 'Attack', component: markRaw(AttackArmoryView), disabled: false },
                { name: 'defense', route: './DefenseArmoryView.vue', label: 'Defense', component: markRaw(DefenseArmoryView), disabled: false }
            ],
            activeTab: 'attack',
        };
    },

    computed: {
        activeComponent() {
            const tab = this.tabs.find(tab => tab.name === this.activeTab);
            console.log('activeTab:', this.activeTab);
            console.log('Found tab:', tab);
            return tab ? tab.component : null;
        }
    },
    methods: {
        updateActiveTab(newTab) {
            this.activeTab = newTab;
        }
    }
}
</script>